import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionComponent } from './components/section/section.component';
import { BsDropdownModule, PaginationModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap';
import { AccordionComponent } from './components/accordion/accordion.component';
import { AccountGroupComponent } from './components/account-group/account-group.component';
import { AccountsGroupsComponent } from './components/accounts-groups/accounts-groups.component';
import { DetailsButtonComponent } from './components/details-button/details-button.component';
import { PaginableListComponent } from './components/paginable-list/paginable-list.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { PermissionsComponent } from './components/permissions/permissions.component';
import { SwitchButtonComponent } from './components/switch-button/switch-button.component';
import { FormsModule } from '@angular/forms';
import { TypeaheadInputComponent } from './components/typeahead-input/typeahead-input.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { CloseButtonComponent } from './components/close-button/close-button.component';
import { AgreementComponent } from './components/agreement/agreement.component';
import { BrandIdentifierComponent } from './components/brand-identifier/brand-identifier.component';
import { CalendarPickerComponent } from './components/calendar-picker/calendar-picker.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { WarningComponent } from './components/warning/warning.component';
import { BasicButtonComponent } from './components/basic-button/basic-button.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { HelpBubbleComponent } from './components/help-bubble/help-bubble.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { createTranslateLoader } from '../../core/core.module';
import { HttpClient } from '@angular/common/http';
import { DeviceCheckerService } from './services/device-checker.service';
import { AuthorizationDialogComponent } from './components/authorization-dialog/authorization-dialog.component';
import { LogoComponent } from './components/logo/logo.component';
import { OutsideClickDirective } from './directives/outside-click/outside-click.directive';
import { AccountFormatPipe } from './pipes/account-format.pipe';
import { LanguageCodePipe } from './pipes/language-code.pipe';
import { LogoBankIdComponent } from './components/logo/logo-bankid.component';


export const COMPONENTS: any[] = [
    LogoComponent,
    LogoBankIdComponent,
    AuthorizationDialogComponent,
    AgreementComponent,
    BrandIdentifierComponent,
    TypeaheadInputComponent,
    SectionComponent,
    BasicButtonComponent,
    AccordionComponent,
    AccountGroupComponent,
    AccountsGroupsComponent,
    DetailsButtonComponent,
    PaginableListComponent,
    PaginatorComponent,
    ListItemComponent,
    PermissionsComponent,
    SwitchButtonComponent,
    SpinnerComponent,
    HelpBubbleComponent,
    SwitchButtonComponent,
    ConfirmDialogComponent,
    CloseButtonComponent,
    CalendarPickerComponent,
    DropdownComponent,
    WarningComponent
];

// directives should be declared here
export const DIRECTIVES: any[] = [
    OutsideClickDirective
];

// pipes should be declared here
export const PIPES: any[] = [
    LanguageCodePipe,
    AccountFormatPipe
];

export const SERVICES: any[] = [
    DeviceCheckerService
];

export const EXPORTED_MODULES: any[] = [
    TooltipModule
];

export const FEATURES = COMPONENTS.concat(PIPES).concat(DIRECTIVES);
export const PROVIDERS = PIPES.concat(SERVICES);

/**
 * Shared module contains shared pieces used by other modules:
 * - components
 * - directives
 * - models
 * - services
 * - pipes
 * - helper functions
 * - and other.
 */
@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        FormsModule,
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        PopoverModule.forRoot(),
        TooltipModule.forRoot(),
        DeviceDetectorModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        TypeaheadModule.forRoot(),
    ],
    exports: FEATURES.concat(EXPORTED_MODULES),
    declarations: FEATURES,
    entryComponents: [PaginatorComponent]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: PROVIDERS
        };
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/shared.module.ts